import { ContextMenuListener } from './types';

const registry = new Map<string, ContextMenuListener>();

export const addContextMenu = (
  identifier: string,
  contextMenuListener: ContextMenuListener
) => registry.set(identifier, contextMenuListener);

export const removeContextMenu = (identifier: string) =>
  registry.delete(identifier);

export const getContextMenu = (identifier: string) => registry.get(identifier);
